module.exports = __webpack_public_path__ + "img/splat.b6b12421.png";